import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StylePropType from 'react-style-proptype';
var DEFAULT = 'default';
var SIMPLE = 'simple';
var NAVTAB = 'navtab';

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.state.open && this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          disabled = _this$props.disabled,
          type = _this$props.type;
      var AsComponent = this.props.as;
      var InnerAsComponent = 'button';

      if (type === NAVTAB) {
        AsComponent = 'li';
        InnerAsComponent = 'a';
      }

      var innerClassName = classNames({
        'btn btn-default dropdown-toggle': type === DEFAULT,
        'btn btn-link': type === SIMPLE,
        clickable: type === NAVTAB
      });
      return React.createElement(AsComponent, {
        className: classNames('dropdown', className, {
          open: open
        }),
        style: style
      }, React.createElement(InnerAsComponent, {
        disabled: !children || !React.Children.count(children) || disabled,
        onClick: this.toggle,
        className: innerClassName
      }, title, " ", (type === DEFAULT || type === NAVTAB) && React.createElement("span", {
        className: "caret"
      })), React.createElement("ul", {
        className: "dropdown-menu",
        onClick: this.toggle
      }, React.Children.map(children, function (child) {
        if (!child) {
          return null;
        }

        if (child.type === 'hr') {
          return React.createElement("li", {
            className: "divider",
            key: child.key
          });
        }

        return React.createElement("li", {
          className: classNames('dropdown-item', {
            disabled: child.props.disabled
          }),
          key: child.key,
          onClick: child.props.disabled ? function (e) {
            return e.stopPropagation();
          } : undefined
        }, child);
      })));
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.propTypes = {
  as: PropTypes.string,
  type: PropTypes.oneOf([DEFAULT, SIMPLE, NAVTAB]),
  children: PropTypes.node,
  title: PropTypes.node,
  className: PropTypes.string,
  style: StylePropType,
  disabled: PropTypes.bool
};
Dropdown.defaultProps = {
  as: 'div',
  disabled: false,
  className: '',
  type: DEFAULT
};
export default enhanceWithClickOutside(Dropdown);